export const Animations = new function() {

    this.init = () => {

        if(document.querySelector('.anim-json')) {

            let animations = document.querySelectorAll('.anim-json');
            animations.forEach( animation => {
                    
                    animation.addEventListener("ready", () => {
                        // animation.resize();
                        // animation.setDirection(1);
                        
                        // animation.seek("50%");
                        // animation.setSpeed(1);
                        
                        // animation.pause();
                        // animation.setDirection(-1);
                        animation.play();
                        // animation.setLooping(true);
                    });
                }
            )
        }
    
        if(document.querySelector('.anim-js')) {

            let animations = document.querySelectorAll('.anim-js');
            animations.forEach( animation => {
                    
                    animation.addEventListener("ready", () => {
                        // animation.resize();
                        // animation.setDirection(1);
                        
                        // animation.seek("50%");
                        // animation.setSpeed(1);
                        
                        // animation.pause();
                        // animation.setDirection(-1);
                        animation.play();
                        animation.setLooping(true);
                    });
                }
            )
        }
    };
    
};